"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_utils_1 = require("@nef/style-utils");
var SidebarWideButtonText_1 = __importDefault(require("../../../components/SidebarWideButtonText"));
var Sidebar_1 = require("../../../Sidebar");
var SidebarButtonText = function (_a) {
    var children = _a.children, className = _a.className;
    var expanded = react_1.default.useContext(Sidebar_1.SidebarContext).expanded;
    if (expanded) {
        return (react_1.default.createElement(SidebarWideButtonText_1.default, { className: style_utils_1.classNames("sidebar--button-text", className) }, children));
    }
    return null;
};
exports.default = SidebarButtonText;
//# sourceMappingURL=index.js.map